import dayjs from 'dayjs';
import { FieldType, IntermediaryDraftDto, IntermediaryResponse } from '@pmp/api';

const toDateOnly = (value: unknown): string | null => {
  if (!value) return null;
  const d = dayjs(value as string);
  return d.isValid() ? d.format('YYYY-MM-DD') : null;
};

export const mapIntermediaryToDto = (values: IntermediaryResponse, record?: IntermediaryResponse | null): IntermediaryDraftDto => {
  const { personalData, compliance } = values;
  return {
    id: values.id ?? record?.id ?? null,
    firmId: values.firmId ?? null,
    email: values.email ?? null,
    title: personalData?.title ?? null,
    firstName: personalData?.firstName ?? null,
    middleName: personalData?.middleName ?? null,
    lastName: personalData?.lastName ?? null,
    preferredName: personalData?.preferredName ?? null,
    displayName: personalData?.displayName ?? null,
    birthDate: toDateOnly(personalData?.birthDate),
    homeAddress: personalData?.homeAddress ?? null,
    regionalOfficeAddress: personalData?.regionalOfficeAddress ?? null,
    mobilePhoneNumber: personalData?.mobilePhoneNumber ?? null,
    workPhoneNumber: personalData?.workPhoneNumber ?? null,
    haveLivedOutsideOfTheUk: personalData?.haveLivedOutsideOfTheUk ?? null,
    previousName: personalData?.previousName ?? null,
    lastComplianceCheck: compliance?.lastComplianceCheck ?? null,
    whoDidLastComplianceCheckUserId: compliance?.whoDidLastComplianceCheckUserId ?? null,
    complianceStatus: compliance?.complianceStatus ?? null,
    reviewRequired: compliance?.reviewRequired ?? null,
    onTheWatchlist: compliance?.onTheWatchlist ?? null,
    roles: values.roles ?? null,
    managerId: values.managerId ?? null,
    subordinateIds: values.subordinateIds ?? null,
    assistantIds: values.assistantIds ?? null,
    assistantForIds: values.assistantForIds ?? null,
    tradingAddressId: values.tradingAddressId ?? record?.tradingAddressId ?? null,
    irn: values.irn ?? null,
    fcaStatus: values.fcaStatus ?? null,
    receiveMarketingMaterials: values.receiveMarketingMaterials ?? null,
    agreedToTermsAndConditions: values.agreedToTermsAndConditions ?? null,
    consentToComplianceChecksBeingCarriedOut: values.consentToComplianceChecksBeingCarriedOut ?? null,
    isAuthorised: values.isAuthorised ?? null,
    ohpenId: values.ohpenId ?? null,
  };
};

export const BROKERS_VALUE_LIST_NAMES: FieldType[] = [
  FieldType.YES_NO,
  FieldType.COMPLIANCE_STATUS,
  FieldType.USER_STATUS,
  FieldType.USER_ROLE_TYPE,
  FieldType.FIRMS,
];
